import React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Hospitalitybanner from '../images/hospitality.jpg';
import HospitalityImage from '../images/small img_Hospitality Operations.jpg';
import BRISBANE_LOGO from '../images/brisbane.jpg';
import CAIRNS_LOGO from '../images/cairns.jpg';
import MetaTags from '../MetaTags';
import { AiOutlineArrowRight } from 'react-icons/ai';
import ServiceFaqSection from '../Components/ServiceFaqSection';
import '../Stlye.css';

const Hospitality = () => {
  return (
    <div className="hospitality">
      <MetaTags
        title="Hospitality Business Operations in Queensland | Smart Resources QLD"
        description="Smart Resources QLD supports hospitality business operations through Punjabi Palace Brisbane and Punjabi Palace Cairns, with a focus on service quality, workflow management, and sustainable performance."
        keywords="hospitality business operations Queensland, hospitality operations Brisbane, hospitality operations Cairns, Punjabi Palace Brisbane, Punjabi Palace Cairns"
        Canonical="https://smartresourcesqld.com.au/operations/hospitality"
        ogImage={Hospitalitybanner}
        ogTitle="Hospitality Business Operations in Queensland | Smart Resources QLD"
        ogDescription="Smart Resources QLD supports hospitality business operations through Punjabi Palace Brisbane and Punjabi Palace Cairns, with a focus on service quality, workflow management, and sustainable performance."
        ogUrl="https://smartresourcesqld.com.au/operations/hospitality"
        DCTitle="Hospitality Business Operations in Queensland | Smart Resources QLD"
        DCDescription="Smart Resources QLD supports hospitality business operations through Punjabi Palace Brisbane and Punjabi Palace Cairns, with a focus on service quality, workflow management, and sustainable performance."
        DCSubject="hospitality business operations Queensland, hospitality operations Brisbane, hospitality operations Cairns, Punjabi Palace Brisbane, Punjabi Palace Cairns"
      />

      <section
        className="innr_banner"
        style={{ backgroundImage: `url(${Hospitalitybanner})`, backgroundPosition: 'center', backgroundSize: 'cover' }}
      >
        <div className="page_title_innr" data-aos="fade-down">
          <div className="page_title">Hospitality Operations</div>
          <ul className="bread_crumb">
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/operations">Operations</NavLink>
            </li>
            <li>Hospitality Operations</li>
          </ul>
        </div>
      </section>

      <section className="pricing servinnrbg">
        <div className="servinnng_middle">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="global_left serv_innr_heading" data-aos="fade-up">
                  <h1>Hospitality Business Operations</h1>
                  <p>
                    Smart Resources QLD is also involved in hospitality
                    business operations through <strong>Punjabi Palace Brisbane</strong> and
                    <strong> Punjabi Palace Cairns</strong>.
                    <br />
                    <br />
                    Our involvement in the hospitality sector reflects hands-on
                    operational experience within fast-paced restaurant
                    environments focused on customer service, operational
                    coordination, and business performance.
                    <br />
                    <br />
                    Through these operations, we understand the importance of
                    maintaining service quality, efficient workflow management,
                    and consistent customer experiences across hospitality
                    businesses.
                  </p>
                  <p>
                    We continue to support structured hospitality operations
                    with a focus on professionalism, service standards,
                    operational consistency, and long-term business
                    sustainability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="discuss-seo seo_price_bg hospitality_inner_bg">
          <div className="container">
            <div className="row discuss-ppc-seo">
              <h2>Need support with hospitality operations?</h2>
              <div className="button-ppc-new">
                <NavLink
                  className="btn-trans"
                  to="/contact-us"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Contact Us
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        <section className="include_services">
          <div className="include_service_innr">
            <div className="container">
              <Row className="align-items-center">
                <Col lg="4" md="6" sm="12">
                  <div className="include_img" data-aos="fade-right">
                    <img
                      src={HospitalityImage}
                      alt="Hospitality operations meeting"
                      className="img-fluid"
                    />
                  </div>
                </Col>

                <Col lg="8" md="6" sm="12">
                  <div className="include_text" data-aos="fade-left">
                    <h3>Hospitality Operations Focus</h3>
                    <div className="pf">
                      <ul>
                        <li>
                          <strong>Punjabi Palace Brisbane and Punjabi Palace
                            Cairns:</strong>{' '}
                          Our hospitality involvement is grounded in real-world
                          operations across these restaurant locations.
                        </li>
                        <li>
                          <strong>Customer service:</strong> We understand how
                          to maintain consistent guest experiences in fast-paced
                          hospitality environments.
                        </li>
                        <li>
                          <strong>Operational coordination:</strong> We support
                          structured workflows that help teams stay efficient
                          and aligned.
                        </li>
                        <li>
                          <strong>Service quality:</strong> We place importance
                          on professional standards that protect the customer
                          experience.
                        </li>
                        <li>
                          <strong>Long-term sustainability:</strong> We continue
                          to support hospitality operations with a focus on
                          consistency, professionalism, and business
                          performance.
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>

            </div>
          </div>
        </section>

        <section className="include_services hospitality_locations">
          <div className="include_service_innr">
            <div className="container">
              <div
                className="global_left serv_innr_heading" data-aos="fade-up"
                style={{ marginBottom: '20px' }}
              >
                <h2>Explore Punjabi Palace Locations</h2>
                <p>
                  Choose a location below to view the hospitality presence in
                  Brisbane or Cairns.
                </p>
              </div>

              <Row className="g-4">
                <Col lg="6" md="6" sm="12">
                  <a
                    href="https://punjabipalace.com.au/brisbane"
                    target="_blank"
                    rel="noreferrer"
                    className="location_card location_card_link"
                  >
                    <div className="location_card_body">
                      <span className="location_card_tag">
                        Click to visit <AiOutlineArrowRight />
                      </span>
                      <img
                        src={BRISBANE_LOGO}
                        alt="Punjabi Palace Brisbane"
                        className="img-fluid"
                      />
                      <h3>
                        Punjabi Palace Brisbane
                      </h3>
                    </div>
                  </a>
                </Col>

                <Col lg="6" md="6" sm="12">
                  <a
                    href="https://punjabipalace.com.au/cairns"
                    target="_blank"
                    rel="noreferrer"
                    className="location_card location_card_link"
                  >
                    <div className="location_card_body">
                      <span className="location_card_tag">
                        Click to visit <AiOutlineArrowRight />
                      </span>
                      <img
                        src={CAIRNS_LOGO}
                        alt="Punjabi Palace Cairns"
                        className="img-fluid"
                      />
                      <h3>
                        Punjabi Palace Cairns
                      </h3>
                    </div>
                  </a>
                </Col>
              </Row>

              <p className="f">
                Contact Smart Resources QLD to learn more about our business
                operations and services.
              </p>
            </div>
          </div>
        </section>

        {/* <ServiceFaqSection
          title="Frequently Asked Questions"
          intro="Quick answers about our hospitality operations and location links."
          faqData={[
            {
              question: 'What hospitality operations does Smart Resources QLD support?',
              answer:
                'We are involved in hospitality business operations through Punjabi Palace Brisbane and Punjabi Palace Cairns, with a focus on service quality, workflow coordination, and business consistency.',
            },
            {
              question: 'Why is operational consistency important in hospitality?',
              answer:
                'Operational consistency helps ensure that guests receive a reliable experience, staff can work efficiently, and service standards remain strong across busy service periods.',
            },
            {
              question: 'How do your hospitality operations reflect your experience?',
              answer:
                'Our experience in fast-paced restaurant environments gives us practical insight into customer service, coordination, and maintaining quality under pressure.',
            },
            {
              question: 'Do you focus on long-term sustainability in hospitality?',
              answer:
                'Yes. We support structured hospitality operations with an emphasis on professionalism, service standards, and long-term business sustainability.',
            },
            {
              question: 'Can customers visit the Punjabi Palace Brisbane and Cairns pages?',
              answer:
                'Yes. The location cards on this page are designed to redirect customers to the respective Brisbane and Cairns pages using external links.',
            },
          ]}
        /> */}
      </section>
    </div>
  );
};

export default Hospitality;
